import {createElement, Component, PropTypes} from 'rlink-react';
import connectToPathForContent from 'rlink-repos/connectToPathForContent';

function ContentDownload ({href, className, children, pathForContent}) {
  return <a href={pathForContent(href)} download={pathForContent(href)} className={className}>
    {children}
  </a>;
}

ContentDownload.propTypes = {
  href: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  pathForContent: PropTypes.func,
};


export default connectToPathForContent(ContentDownload);



// WEBPACK FOOTER //
// ./lib/rlink-repos/components/ContentDownload.jsx